import React, { useEffect, useState } from 'react';
import { Wrapper } from '../../../components/Wrapper';
import {
  Box,
  Text,
  Flex,
  Icon,
  Grid,
  GridItem,
  useBreakpointValue,
} from '@chakra-ui/react';
import { If, Then, Else } from 'react-if';
import Skeleton from 'react-loading-skeleton';
import { useIsAuthenticated } from 'react-auth-kit';
import { checkAndRedirectToProfile } from '../../../../utils/authUtils';

import PengetahuanController, {
  usePengetahuanContext,
} from '../../../controller/pengetahuan/index';
import Pagination from '../../../components/Pagination';
import CardItem from '../../../components/global/Card/CardItem';
import CardItemSync from '../../../components/global/Card/CardItemSync';
import CategoryPengetahuan from '../../../components/Pengetahuan/CategoryPengetahuan';
import ShapeHeroPelatihan from '../../../assets/webp/shape-hero-pelatihan.webp';
import { PiHeadCircuitFill } from 'react-icons/pi';

const HeroPengetahuan: React.FC = () => {
  const { setState, getListKategoriPengetahuan, getJenjang } = usePengetahuanContext();
  const { keyword } = usePengetahuanContext().state;

  const [searchInput] = useState(keyword);

  const isMobile = useBreakpointValue({ base: true, md: false });

  useEffect(() => {
    const handler = setTimeout(() => {
      setState((prev: any) => ({
        ...prev,
        keyword: searchInput,
      }));
    }, 500);

    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInput]);

  useEffect(() => {
    getListKategoriPengetahuan();
    getJenjang();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box
        w="100%"
        bg="#15803D"
        color="white"
        position="relative"
        overflow="hidden"
      >
        {!isMobile && (
          <Box
            position="absolute"
            top="0"
            right="0"
            h="100%"
            w={{ base: '200px', md: '400px' }}
            backgroundImage={`url(${ShapeHeroPelatihan})`}
            backgroundRepeat="no-repeat"
            backgroundPosition="right top"
            backgroundSize="contain"
            pointerEvents="none"
          />
        )}

        <Box maxW="1512px" mx="auto" px={['20px', '20px', '60px']}>
          <Box py="60px" textAlign="center">
            <Box
              w="60px"
              h="60px"
              bg="white"
              borderRadius="8px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              mx="auto"
              mb="24px"
            >
              <Icon as={PiHeadCircuitFill} boxSize={8} color="#15803D" />
            </Box>
            <Text
              fontSize={{ base: '18px', md: '24px' }}
              fontWeight="700"
              lineHeight="1.3"
            >
              Mari Belajar Melalui Pusat Berbagi Pengetahuan
            </Text>
          </Box>
        </Box>
      </Box>

      {/* <Box
        position="relative"
        backgroundImage={`url(${BgNewPintar})`}
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        py={[10, 10, 16]}
      >
        <Box maxW="1200px" mx="auto" px={[4, 4, 8]}>
          <Box bg="white" p={[4, 4, 8]} borderRadius="xl" boxShadow="lg">
            <div style={{ marginBottom: '24px', position: 'relative' }}>
              <Input
                placeholder="Cari disini..."
                fontSize="16px"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                size="lg"
                pr="40px"
              />
              <div
                style={{
                  position: 'absolute',
                  right: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                }}
              >
                <FaSearch color="green" />
              </div>
            </div>

            <Grid
              templateColumns={{
                base: 'repeat(1, 1fr)',
                md: 'repeat(2, 1fr)',
                lg: 'repeat(5, 1fr)',
              }}
              gap={4}
              alignItems="end"
            >
              <Box>
                <Text mb={2} fontSize="16px" fontWeight="medium">
                  Jenjang
                </Text>
                <Select
                  placeholder="Pilih jenjang"
                  fontSize="16px"
                  value={jenjangFilter}
                  onChange={(e) => {
                    const value = e.target.value;
                    setJenjangFilter(value);
                    setKelasFilter('');
                    setMapelFilter('');
                    setState((prev: any) => ({
                      ...prev,
                      jenjang: value,
                      kelas: '',
                      mapel: '',
                    }));
                  }}
                >
                  {jenjangList.map((item: any) => (
                    <option key={item.jenjang} value={item.jenjang}>
                      {item.jenjang}
                    </option>
                  ))}
                </Select>
              </Box>

              <Box>
                <Text mb={2} fontSize="16px" fontWeight="medium">
                  Kelas
                </Text>
                <Select
                  placeholder="Pilih Kelas"
                  value={kelasFilter}
                  fontSize="16px"
                  isDisabled={!jenjangFilter || kelasList.length === 0}
                  onChange={(e) => {
                    setKelasFilter(e.target.value);
                    setState((prev: any) => ({
                      ...prev,
                      kelas: e.target.value,
                    }));
                  }}
                >
                  {kelasList.map((item: any) => (
                    <option value={item.kelas} key={item.kelas}>
                      Kelas {item.kelas}
                    </option>
                  ))}
                </Select>
              </Box>

              <Box>
                <Text mb={2} fontSize="16px" fontWeight="medium">
                  Mapel
                </Text>
                <Select
                  placeholder="Pilih Mapel"
                  value={mapelFilter}
                  fontSize="16px"
                  isDisabled={!jenjangFilter || mataPelajaranList.length === 0}
                  onChange={(e) => {
                    setMapelFilter(e.target.value);
                    setState((prev: any) => ({
                      ...prev,
                      mapel: e.target.value,
                    }));
                  }}
                >
                  {mataPelajaranList.map((item: any) => (
                    <option value={item.id} key={item.id}>
                      {item.mata_pelajaran}
                    </option>
                  ))}
                </Select>
              </Box>

              <Box>
                <Text mb={2} fontSize="16px" fontWeight="medium">
                  Tipe
                </Text>
                <Select
                  placeholder="Pilih Tipe"
                  fontSize="16px"
                  onChange={(e) => {
                    setState((prev: any) => ({
                      ...prev,
                      sort_by: e.target.value,
                    }));
                  }}
                >
                  <option value="terbaru">Terbaru</option>
                  <option value="penayangan terbanyak">
                    Penayangan Terbanyak
                  </option>
                  <option value="rating tertinggi">Rating Tertinggi</option>
                </Select>
              </Box>

              <Box>
                <Button
                  bg={'green.900'}
                  color={'white'}
                  w="full"
                  type="button"
                  fontSize="16px"
                  onClick={handleResetFilter}
                  _hover={{ bg: 'green.800' }}
                >
                  Reset Filter
                </Button>
              </Box>
            </Grid>
          </Box>
        </Box>
      </Box> */}
    </>
  );
};

const ListPengetahuan = (): JSX.Element => {
  const { fetchData, setState } = usePengetahuanContext();
  const {
    isLoading,
    listData,
    category,
    kategori_pengetahuan_id,
    jenjang,
    kelas,
    mapel,
    pagination,
    page,
    perPage,
    sort_by,
    keyword,
  } = usePengetahuanContext().state;

  const totalPage = pagination?.last_page ?? 0;

  const handlePageChange = (e: any) => {
    setState((prev: any) => ({
      ...prev,
      page: e.selected + 1,
    }));
  };

  useEffect(() => {
    fetchData({ jenis_pengetahuan: 'asynchronized' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    category,
    kategori_pengetahuan_id,
    jenjang,
    kelas,
    mapel,
    sort_by,
    page,
    perPage,
    keyword,
  ]);

  return (
    <Box mx={{ base: 4, md: 8 }} my={10}>
      <Grid templateColumns={'repeat(6, 1fr)'} gap={4}>
        <GridItem colSpan={{ base: 6, md: 1 }}>
          <CategoryPengetahuan page="page" type="async" />
        </GridItem>

        <GridItem colSpan={{ base: 6, md: 5 }}>
          <If condition={isLoading}>
            <Then>
              <Skeleton
                count={4}
                style={{ height: '400px', width: '280px', marginRight: '20px' }}
                inline={true}
              />
            </Then>
            <Else>
              <If condition={listData.length > 0}>
                <Then>
                  <Grid
                    gap={8}
                    templateColumns={{
                      base: 'repeat(1fr)',
                      sm: 'repeat(2, 1fr)',
                      md: 'repeat(3, 1fr)',
                    }}
                  >
                    {listData.map((item: any, key: number) => {
                      return item.jenis_pengetahuan === 'synchronized' ? (
                        <CardItemSync
                          item={item}
                          spacing={false}
                          key={key}
                          accessFor="pengetahuan"
                        />
                      ) : (
                        <CardItem
                          item={item}
                          spacing={false}
                          key={key}
                          accessFor="pengetahuan"
                        />
                      );
                    })}
                  </Grid>
                </Then>
                <Else>
                  <Box textAlign="center" mt={20}>
                    <Text fontSize="xl" color="gray.400">
                      Belum Ada Pengetahuan
                    </Text>
                  </Box>
                </Else>
              </If>
            </Else>
          </If>

          {pagination && totalPage > 1 && (
            <Flex justifyContent="center" mt={8}>
              <Pagination
                handleChange={handlePageChange}
                totalPage={totalPage}
                page={page}
              />
            </Flex>
          )}
        </GridItem>
      </Grid>
    </Box>
  );
};

const WrapperMain: React.FC = () => {
  // use is authenticated
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    checkAndRedirectToProfile(isAuthenticated());
  }, [isAuthenticated]);

  return (
    <Wrapper>
      {/* Hero */}
      <HeroPengetahuan />

      {/* List Pengetahuan */}
      <ListPengetahuan />
    </Wrapper>
  );
};

const DaftarPengetahuan: React.FC = () => {
  return (
    <PengetahuanController.Provider>
      <WrapperMain />
    </PengetahuanController.Provider>
  );
};

export default DaftarPengetahuan;
